import React from 'react';

export interface ModalFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({ children, className = '', ...props }) => {
  return (
    <div className={`flex items-center justify-end gap-2 px-4 py-3 bg-[var(--color-gray-50)] border-t border-[var(--color-gray-200)] rounded-b-lg ${className || ''}`} {...props}>
      {children}
    </div>
  );
};
